import { Month } from "../enum/month.enum";

/**
 * Get the current date
 * @returns 
 */
export function getCurrentDate(): Date {
    return new Date();
}

/**
 * Create a date
 * @param year 
 * @param month 
 * @param day 
 * @returns 
 */
export function createDate(year: number, month: Month, day: number): Date {
    return new Date(year, month, day);
}

/**
 * Create a date with the provided ISO date string
 * @param isoDate 
 * @returns 
 */
export function createDateFromIso(isoDate: string): Date {
    return new Date(isoDate);
}

/**
 * Add days to the provided date
 * @param date 
 * @param days 
 * @returns 
 */
export function addDays(date: Date, days: number): Date {
    return new Date(date.setDate(date.getDate() + days));
}

/**
 * Add days to current date
 * @param days 
 */
export function addDaysToCurrentDate(days: number): Date {
    const current = getCurrentDate();
    return addDays(current, days);
}

/**
 * Add months to the provided date
 * @param date 
 * @param days 
 * @returns 
 */
export function addMonths(date: Date, months: number): Date {
    return new Date(date.setMonth(date.getMonth() + months));
}

/**
 * Add months to the current date
 * @param months 
 * @returns 
 */
export function addMonthsToCurrentDate(months: number): Date {
    const current = getCurrentDate();
    return addMonths(current, months);
}

/**
 * Helper method for transforming object to ISO date
 * @param body 
 */
export function transformToISODate(body: any = {}): void {
    for (const key in body) {
        const attribute = body[key];

        if (attribute instanceof Date) {
            body[key] = attribute.toISOString();
        }
    }
}